/* eslint-disable */
import { SIDEBAR_CLOSE } from '../Sidebar.types';

/**
 * Close the sidebar
 * @returns {ActionCreator<FromPayload<null, {}, SIDEBAR_CLOSE>>} The created `Action`
 */
const sidebarClose = () => ({ fromPayload }) => {
  return fromPayload(null, {}, SIDEBAR_CLOSE);
};

export default sidebarClose;
